<template>
  <div>
    <b-tabs v-model="addressTypesTab">
      <b-tab :title="$gettext('Automatic by Item Position')" v-if="ecosystemModules.geofences && checkpoint === 'from' && shipping.items && shipping.items[0] && shipping.items[0].item_tracking && shipping.items[0].item_tracking.lat && shipping[checkpoint].coords.lat">
        <p></p>
      </b-tab>
      <b-tab :title="$gettext('By GeoFence')" v-if="ecosystemModules.geofences">
        <b-form-row>
          <div class="form-group col my-3">
            <label for="checkpoint-geofence" v-translate>Type to search</label>
            <geofence-autocomplete id="checkpoint-geofence" :restrict-to-levels="[0]" :includes="['geo_type', 'geo_fences.geo_type', 'geo_lines.geo_type', 'geo_points.geo_type']" @selected="selectedGeoFence" />
          </div>
        </b-form-row>
      </b-tab>
      <b-tab :title="$gettext('By Address')">
        <b-form-row>
          <div class="form-group col-sm-8 my-3">
            <label for="from_extra" v-translate>Street and number</label>
            <div class="input-group" v-if="!shipping[checkpoint].placeId">
              <address-autocomplete ref="addressAutocomplete" @selected="selected" :min-character="6" static-items />
            </div>
            <p v-if="shipping[checkpoint].googlePlaceString">
              {{ shipping[checkpoint].googlePlaceString }}
              <b-badge variant="danger" href="#" @click.prevent="resetPlace">×</b-badge>
            </p>
          </div>
          <div class="form-group col-sm-4 my-3">
            <label for="destination-floor" v-translate>Floor, door, etc.</label>
            <div class="input-group">
              <b-form-input id="destination-floor" v-model="shipping[checkpoint].floor" />
            </div>
          </div>
        </b-form-row>
      </b-tab>
    </b-tabs>
    <div v-if="shipping[metaType] && shipping[metaType].geofences[checkpoint].external_id">
      <p class="m-0" v-translate>Selected GeoFence</p>
      <h4><strong>{{shipping[metaType].geofences[checkpoint].external_id | cleanentityprefix}}</strong> {{shipping[metaType].geofences[checkpoint].name | cleanentityprefix}} ({{shipping[metaType].geofences[checkpoint].reference_location}})</h4>
    </div>
    <div v-if="ecosystemConfig.extraCheckpoints && ecosystemConfig.extraCheckpoints['before' + extraCheckpointsEvent]">
      <b-form-row v-if="!shipping[metaType].extraCheckpoints || !shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent] || shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent].length === 0">
        <b-col class="text-center mb-4">
          <b-button v-b-modal="'modalPickEntrancePlace' + checkpoint" :disabled="!shipping[checkpoint].lat && (shipping[checkpoint].coords && !shipping[checkpoint].coords.lat)" v-if="shipping[metaType].geofences[checkpoint].id" v-translate>Select Place Extra Data</b-button>
          <b-modal size="xl" :id="'modalPickEntrancePlace' + checkpoint" :ref="'modalPickEntrancePlace' + checkpoint" hide-footer hide-header>
            <geodata-picker ref="pickEntrancePlaceMap" @ready="setEntrancePlaceCenter" @cancel="closeModalPickEntrancePlace" @selectedElements="setExtraCheckpointsSelectedElements" centerMap fit-always :zoom="17" height="500px" />
          </b-modal>
          <b-button v-b-modal="'modalPickEntryPoint' + checkpoint" :disabled="!shipping[checkpoint].lat && (shipping[checkpoint].coords && !shipping[checkpoint].coords.lat)" v-if="!shipping[metaType].geofences[checkpoint].id" v-translate>Pick Single Entry point</b-button>
          <b-modal size="xl" :id="'modalPickEntryPoint' + checkpoint" :ref="'modalPickEntryPoint' + checkpoint" hide-footer hide-header>
            <place-picker ref="pickEntrancePlaceMap" @ready="setEntrancePlaceCenter" @cancel="closeModalPickEntrancePlace" @placePicked="setEntrancePlacePicked" centerMap fit-always :zoom="17" height="500px" />
          </b-modal>
        </b-col>
      </b-form-row>
      <b-form-row v-else>
        <b-card>
          <h5>
            <translate>Place Extra Data</translate>
            <b-button size="sm" variant="warning" v-b-modal="'modalPickEntrancePlace' + checkpoint" v-if="shipping[metaType].extraCheckpoints && shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent] && shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent].filter(x => x.dupe).length > 0">
              <font-awesome-icon icon="clipboard-list" />
            </b-button>
          </h5>
          <b-modal size="xl" :id="'modalPickEntrancePlace' + checkpoint" :ref="'modalPickEntrancePlace' + checkpoint" hide-footer hide-header>
            <place-picker v-if="!ecosystemModules.geofences" ref="pickEntrancePlaceMap" @ready="setEntrancePlaceCenter" @cancel="closeModalPickEntrancePlace" @placePicked="setEntrancePlacePicked" centerMap fit-always :zoom="17" height="500px" />
            <geodata-picker v-else ref="pickEntrancePlaceMap" :parent-data="shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent]" @ready="setEntrancePlaceCenter" @cancel="closeModalPickEntrancePlace" @selectedElements="setExtraCheckpointsSelectedElements" centerMap fit-always :zoom="17" height="500px" />
          </b-modal>
          <span class="bg-danger text-white d-block text-center" style="cursor: pointer; width: 1rem; height: 1rem; line-height: 1rem; position: absolute; top: 0; left: 0" href="#" @click.prevent="shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent] = []">×</span>
          <p v-if="shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].place" class="m-0">
            <b-button size="sm" @click.stop="openMapOn(shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].place.formatted_address + '/@' + shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].place.lat + ',' + shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].place.lng + ',17z')" class="py-0 px-1" :title="$gettext('Quick view address map on new window')">
              <font-awesome-icon :icon="['fa', 'map-marked-alt']" size="2x" style="font-size: 10px; vertical-align: middle;" />
            </b-button>
            {{shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].place.formatted_address}}
            <em>
              ({{shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].place.lat}}, {{shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].place.lng}})
            </em>
          </p>
          <b-list-group v-if="shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].geo_type_id">
            <b-list-group-item v-for="(element, index) in shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent]" :key="'beforePickup' + index" class="p-2">
              <span v-if="element.dupe">
                <font-awesome-icon icon="exclamation-triangle" class="text-warning" />
              </span>
              <strong>{{element.external_id | cleanentityprefix}}</strong> {{ element.name | cleanentityprefix }} <small>[{{ element.geo_type ? element.geo_type.name : geoTypes.find(x => x.id === element.geo_type_id).name }}]</small>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-form-row>
    </div>

    <b-modal size="lg" id="modalPickPlace" ref="modalPickPlace" hide-footer hide-header>
      <place-picker ref="pickPlaceMap" :hasReference="checkpoint === 'from'" @cancel="closeModalPickPlace" @placePicked="setPlacePicked" centerMap fit-always :zoom="17" />
    </b-modal>

  </div>
</template>

<script>
import {
  GeofenceService
} from '@/services/api'
import AddressesMixin from '@/mixins/address.mixin'
import ShippingsMixin from '@/mixins/shippings.mixin'
import CompanyAutocomplete from '@/components/Autocompletes/CompanyAutocomplete'
import AddressAutocomplete from '@/components/Autocompletes/AddressAutocomplete'
import Cleave from 'vue-cleave'
import LeafletMap from '@/components/Maps/LeafletMap'
import PlacePicker from '@/components/PlacePicker'
import GeodataPicker from '@/components/GeodataPicker'
import GeofenceAutocomplete from '@/components/Autocompletes/GeofenceAutocomplete'
export default {
  name: 'CompanyNewShipping',
  components: {
    CompanyAutocomplete,
    AddressAutocomplete,
    Cleave,
    LeafletMap,
    PlacePicker,
    GeodataPicker,
    GeofenceAutocomplete
  },
  props: {
    shipping: {
      type: Object,
      default: () => {},
      required: true
    },
    checkpoint: {
      type: String,
      default: 'from'
    },
    metaType: { // TODO: abstract the component for use with B2B API and normal API
      type: String,
      default: 'conf'
    }
  },
  data() {
    return {
      extraCheckpointsEvent: 'Pickup',
      defaultShippingFields: {
        placeId: null,
        googlePlaceString: null,
        lat: null,
        lng: null,
        street: '',
        number: '',
        floor: '',
        apartment: '',
        city: '',
        state: '',
        postalCode: '',
        country: 'AR',
        instructions: '',
        contact: {
          firstName: '',
          lastName: '',
          email: '',
          phone: ''
        },
        message: ''
      },
      markers: [],
      addressTypesTab: 0,
      overrideAutomaticByItemPosition: false
    }
  },
  watch: {
    'shipping.from.coords': {
      deep: true,
      handler(newValue, oldValue) {
        this.init()
      }
    },
    addressTypesTab(val) {
      if (this.checkpoint === 'from' && val === 0) {
        this.overrideAutomaticByItemPosition = false
        this.setByItemPosition()
      }
    }
  },
  mixins: [
    AddressesMixin,
    ShippingsMixin
  ],
  mounted() {
    this.extraCheckpointsEvent = this.checkpoint === 'to' ? 'Delivery' : this.extraCheckpointsEvent

    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      if (!this.overrideAutomaticByItemPosition && this.ecosystemModules.geofences && this.checkpoint === 'from' && this.shipping[this.checkpoint].coords && this.shipping[this.checkpoint].coords.lat) {
        const params = {
          includes: [
            'geo_type',
            'geo_fences.geo_type',
            'geo_lines.geo_type',
            'geo_points.geo_type',
            'parent_geo_fences.geo_type',
            'parent_geo_fences.geo_fences.geo_type',
            'parent_geo_fences.geo_lines.geo_type',
            'parent_geo_fences.geo_points.geo_type'
          ],
          filter_groups: [
            {
              filters: [
                ['boundary', 'eq', this.shipping[this.checkpoint].coords.lat + ',' + this.shipping[this.checkpoint].coords.lng + '|' + this.shipping[this.checkpoint].coords.lat + ',' + this.shipping[this.checkpoint].coords.lng]
              ]
            }
          ]
        }
        GeofenceService.getAll({ params })
          .then(response => {
            if (response.body.data.length > 0) {
              this.$nextTick(() => {
                this.shipping[this.checkpoint].googlePlaceString = null
                this.shipping[this.checkpoint].placeId = null
                if (response.body.data[0].parent_geo_fences.length > 0) {
                  this.shipping[this.metaType].geofences[this.checkpoint] = response.body.data[0].parent_geo_fences[0]
                  this.shipping[this.metaType].extraCheckpoints['before' + this.extraCheckpointsEvent] = this.checkForAutoExtraCheckpoints(response.body.data[0].parent_geo_fences[0])
                  this.shipping[this.checkpoint].contact.firstName = response.body.data[0].parent_geo_fences[0].external_id + ' - ' + response.body.data[0].parent_geo_fences[0].name
                } else {
                  this.shipping[this.metaType].geofences[this.checkpoint] = response.body.data[0]
                  this.shipping[this.metaType].extraCheckpoints['before' + this.extraCheckpointsEvent] = this.checkForAutoExtraCheckpoints(response.body.data[0])
                  this.shipping[this.checkpoint].contact.firstName = response.body.data[0].external_id + ' - ' + response.body.data[0].name
                }
              })
              this.addressTypesTab = 0
            }
          })
      }
    },
    async selectedGeoFence(item) {
      const cleanupDupes = item.fence && item.fence.coordinates ? [Array.from(new Set(item.fence.coordinates[0].map(a => a.join('|'))), s => s.split('|').map(Number))] : null
      item.fence = cleanupDupes
        ? cleanupDupes.map(x => {
          return x.map(y => [y[1], y[0]])
        })[0]
        : item.fence

      const coords = this.getCenter(item.fence)

      await this.checkPlaceByCoords(coords[0], coords[1])
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.setPlacePicked(this.theCheckedAddress)
        } else if (this.theCheckedAddress.validAddress === false) {
          this.$refs.modalPickPlace.show()
          setTimeout(function () {
            this.$refs.pickPlaceMap.center = [
              this.theCheckedAddress.lat,
              this.theCheckedAddress.lng
            ]
            this.$refs.pickPlaceMap.styles = 'height: 500px;'
          }.bind(this), 100)
        }
      })
      this.shipping[this.metaType].geofences[this.checkpoint] = item
      this.shipping[this.metaType].extraCheckpoints['before' + this.extraCheckpointsEvent] = this.checkForAutoExtraCheckpoints(item)
      this.shipping[this.checkpoint].googlePlaceString = this.shipping[this.checkpoint].addressDescription = this.theCheckedAddress.formatted_address
      this.shipping[this.checkpoint].contact.firstName = item.external_id + ' - ' + item.name
      this.overrideAutomaticByItemPosition = true
    },
    setPlacePicked(place) {
      if (this.checkpoint === 'from') {
        this.defaultShippingFields.placeId = place.id
        this.defaultShippingFields.googlePlaceString = place.formatted_address
        this.defaultShippingFields.lat = place.lat
        this.defaultShippingFields.lng = place.lng
      }

      this.shipping[this.checkpoint].placeId = place.id
      this.shipping[this.checkpoint].googlePlaceString = place.formatted_address
      this.shipping[this.checkpoint].lat = place.lat
      this.shipping[this.checkpoint].lng = place.lng
      this.shipping[this.checkpoint].addressDescription = place.formatted_address
      this.shipping[this.checkpoint].coords.lat = place.lat
      this.shipping[this.checkpoint].coords.lng = place.lng

      this.$refs.modalPickPlace.hide()
      this.emitPlaceSelected([place.lat, place.lng])
    },
    closeModalPickPlace() {
      this.$refs.modalPickPlace.hide()
    },
    emitPlaceSelected(coords) {
      this.$emit('place-selected', coords, this.checkpoint)
    },
    async selected(item) {
      if (item.reference) {
        this.shipping[this.checkpoint].contact.firstName = item.contact
        this.shipping[this.checkpoint].contact.email = item.email
        this.shipping[this.checkpoint].contact.phone = item.phone
      }
      await this.checkPlace(item)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.setPlacePicked(this.theCheckedAddress)
        } else if (this.theCheckedAddress.validAddress === false) {
          this.$refs.modalPickPlace.show()
          setTimeout(function () {
            this.$refs.pickPlaceMap.center = [
              this.theCheckedAddress.lat,
              this.theCheckedAddress.lng
            ]
            this.$refs.pickPlaceMap.styles = 'height: 500px;'
          }.bind(this), 100)
        }
      })
      this.shipping[this.checkpoint].googlePlaceString = this.formattedDisplay(item)
      this.shipping[this.metaType].extraCheckpoints['before' + this.extraCheckpointsEvent] = []
      this.shipping[this.metaType].geofences[this.checkpoint] = {}
    },
    setByItemPosition() {
      if (this.ecosystemModules.geofences && this.checkpoint === 'from' && this.shipping[this.checkpoint].coords.lat && this.shipping.items && this.shipping.items.length > 0 && this.shipping.items[0].item_tracking.lat) {
        this.shipping[this.checkpoint].coords = {
          lat: this.shipping.items[0].item_tracking.lat,
          lng: this.shipping.items[0].item_tracking.lng
        }
        this.shipping[this.checkpoint].lat = this.shipping.items[0].item_tracking.lat
        this.shipping[this.checkpoint].lng = this.shipping.items[0].item_tracking.lng
        this.shipping[this.checkpoint].addressDescription = this.shipping.items[0].item_tracking.meta.address
        this.init()
      }
    },
    setEntrancePlacePicked(place) {
      delete place.raw
      this.shipping[this.metaType].extraCheckpoints['before' + this.extraCheckpointsEvent] = [
        {
          place,
          order: 0
        }
      ]

      this.closeModalPickEntrancePlace()
    },
    setExtraCheckpointsSelectedElements(elements) {
      // FIXME: for now we store the complete data of each element, look on next TODO
      this.shipping[this.metaType].extraCheckpoints['before' + this.extraCheckpointsEvent] = elements.map(x => {
        if (x.originalFence) {
          x.fence = x.originalFence
          delete x.coordinates
          delete x.originalFence
        }
        if (x.originalPath) {
          x.path = x.originalPath
          delete x.coordinates
          delete x.originalPath
        }
        return x
      })
      // TODO: store just ID and type and make all needed requests to gather the elements data
      // .map(x => {
      //   return {
      //     id: x.id,
      //     type: x.type
      //   }
      // })

      this.closeModalPickEntrancePlace()
    },
    setEntrancePlaceCenter() {
      this.$refs.pickEntrancePlaceMap.center = [(this.shipping[this.checkpoint].lat || this.shipping[this.checkpoint].coords.lat), (this.shipping[this.checkpoint].lng || this.shipping[this.checkpoint].coords.lng)]
      this.$refs.pickEntrancePlaceMap.markers[0] = this.$refs.pickEntrancePlaceMap.transformMarker({
        id: '0',
        lat: (this.shipping[this.checkpoint].lat || this.shipping[this.checkpoint].coords.lat),
        lng: (this.shipping[this.checkpoint].lng || this.shipping[this.checkpoint].coords.lng),
        icon: {
          type: this.ecosystemModules.items.icon.type,
          size: this.ecosystemModules.items.icon.size,
          anchor: this.ecosystemModules.items.icon.anchor,
          color: '#000',
          text: this.ecosystemModules.items.icon.text
        }
      })
    },
    closeModalPickEntrancePlace() {
      this.$refs['modalPickEntrancePlace' + this.checkpoint].hide()
    },
    formattedDisplay(result) {
      return result.main_text + ', ' + result.secondary_text
    },
    emitSuccess() {
      this.$emit('success', true)
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    resetPlace() {
      this.shipping[this.checkpoint] = {
        ...this.shipping[this.checkpoint],
        ...{
          googlePlaceString: null,
          addressDescription: null,
          placeId: null,
          lat: null,
          lng: null,
          coords: {
            lat: null,
            lng: null
          }
        }
      }
    },
    getCenter(coordinates) {
      return coordinates.reduce(function (x, y) {
        return [x[0] + y[0] / coordinates.length, x[1] + y[1] / coordinates.length]
      }, [0, 0])
    }
  }
}
</script>
